import { Link } from "react-router-dom";
import { featuredComics } from "@/mocks/comics";

const coverUrls: Record<string, string> = {
  "featured-01": "https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20stunning%20young%20woman%20with%20long%20dark%20hair%20and%20elegant%20makeup%2C%20soft%20pastel%20background%20with%20cherry%20blossoms%20and%20sparkles%2C%20romantic%20atmosphere%2C%20clean%20lineart%2C%20webtoon%20art%20style%2C%20gentle%20lighting%2C%20simple%20gradient%20backdrop%20in%20warm%20pink%20tones%2C%20editorial%20quality%20portrait%20composition&width=700&height=980&seq=featured-01&orientation=portrait",
  "featured-02": "https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20illustration%20of%20a%20powerful%20male%20warrior%20with%20dark%20hair%20and%20glowing%20purple%20eyes%2C%20holding%20a%20dagger%20in%20dynamic%20pose%2C%20dark%20atmospheric%20background%20with%20magical%20energy%20wisps%2C%20action%20webtoon%20aesthetic%2C%20dramatic%20lighting%20from%20above%2C%20clean%20simple%20backdrop%20with%20deep%20shadows%2C%20cinematic%20composition&width=700&height=980&seq=featured-02&orientation=portrait",
  "featured-03": "https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20art%20style%20illustration%20of%20a%20beautiful%20noblewoman%20in%20a%20lavish%20Victorian%20gown%20with%20blonde%20hair%20and%20blue%20eyes%2C%20standing%20in%20a%20grand%20palace%20ballroom%2C%20fantasy%20romance%20webtoon%20aesthetic%2C%20soft%20warm%20candlelight%20glow%2C%20elegant%20composition%20with%20clean%20simple%20background%20in%20golden%20and%20cream%20tones&width=700&height=980&seq=featured-03&orientation=portrait",
  "featured-04": "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20handsome%20young%20man%20with%20stylish%20hair%20and%20confident%20expression%2C%20wearing%20modern%20streetwear%20fashion%2C%20urban%20cityscape%20background%20at%20sunset%2C%20drama%20webtoon%20aesthetic%2C%20warm%20golden%20hour%20lighting%2C%20clean%20composition%20with%20soft%20bokeh%20effect%20background&width=700&height=980&seq=featured-04&orientation=portrait",
};

export default function FeaturedComics() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300/60 text-xs font-semibold text-accent-600 bg-accent-50/50 whitespace-nowrap">
            精选推荐
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
            不可错过的韩漫神作
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            编辑部精心挑选，每一部都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuredComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={coverUrls[comic.coverSeq]}
                  alt={comic.title}
                  title={`${comic.title} - ${comic.category}韩国漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full text-[10px] font-semibold bg-background-50/90 text-foreground-950 whitespace-nowrap">
                    {comic.category}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent p-4">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-xs text-secondary-500" />
                    <span className="text-xs font-semibold text-background-50">
                      {comic.rating}
                    </span>
                    <span className="text-[10px] text-background-50/60 ml-1">
                      {comic.views} 阅读
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold font-heading text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-400">
                  {comic.author} · {comic.status}
                </p>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {comic.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
